import {forwardRef} from 'react'
import {useNavigate} from 'react-router-dom'
import Style from './style'
import logo from '../logo.png'

// Mock PrizeAutoScroll for now if it doesn't exist, or implement a simple list variant
const PrizeListMock = ({prize_editor}) => {
	return (
		<Style.PrizeList $itemCount={prize_editor?.length}>
			{prize_editor?.map((prize, idx) => (
				<div key={idx}>
					<p>{prize.rank || prize.name}</p>
					<p>{prize.amount || prize.prize}</p>
				</div>
			))}
		</Style.PrizeList>
	)
}

const Wrapper = forwardRef(
	(
		{
			children,
			title,
			infoData,
			logoImg,
			timeData,
			countDown,
			eventData,
			prizeData,
			prize_editor,
			prize_list,
			duration,
		},
		ref
	) => {
		const navigate = useNavigate()
		const themeCookie = 'basic' // Default theme for preview
		const isBreak = timeData?.level === 'break'
		const isPaused = timeData?.pause

		return (
			<>
				{isPaused && (
					<Style.PauseCover $isBreak={isBreak}>
						<p>PAUSE</p>
					</Style.PauseCover>
				)}

				<Style.Wrapper ref={ref} $themeType={themeCookie}>
					{isBreak ? (
						<>
							<Style.BreakTitleDiv $themeType={themeCookie}>
								<button onClick={() => navigate(-1)}>
									<Style.BackIcon $themeType={themeCookie}>←</Style.BackIcon>
								</button>
								<Style.BreakTitleContainer>
									<Style.BreakTitle $themeType={themeCookie}>
										<h2>BREAK TIME</h2>
										<p>
											<span>{countDown || '00:00'}</span>
										</p>
									</Style.BreakTitle>
									<Style.BreakSubTitle $themeType={themeCookie}>
										{timeData?.next_level === 'break' ? (
											<h2>NEXT BLINDS BREAK TIME</h2>
										) : (
											<h2>
												NEXT BLINDS {timeData?.next_sb} / {timeData?.next_bb} (
												{timeData?.next_ante})
											</h2>
										)}
									</Style.BreakSubTitle>
								</Style.BreakTitleContainer>
								<button>{/* Setting button removed for preview */}</button>
							</Style.BreakTitleDiv>
						</>
					) : (
						<Style.TitleDiv $themeType={themeCookie}>
							<button onClick={() => navigate(-1)}>
								<Style.BackIcon $themeType={themeCookie}>←</Style.BackIcon>
							</button>
							<h2>{title}</h2>
							<button>{/* Setting button removed for preview */}</button>
						</Style.TitleDiv>
					)}

					<Style.ContentDiv>{children}</Style.ContentDiv>

					<Style.FooterDiv $themeType={themeCookie}>
						{infoData?.map((elem, index) => {
							// Filter logic same as original
							if (
								elem?.label === 'Re-Entry' ||
								elem?.label === 'Early' ||
								elem?.label === 'Add-on'
							)
								return null

							if (elem?.label === 'Re-Entry / Early / Add-on') {
								// Simplified logic for preview
								return (
									<Style.FooterInfo key={index}>
										<h2>
											Re-Entry {eventData?.early_chip ? ' / Early' : null}{' '}
											{eventData?.add_on_chip ? ' / Add-on' : null}
										</h2>
										<p>{elem?.data}</p>
									</Style.FooterInfo>
								)
							}
							return (
								<Style.FooterInfo key={index} $themeType={themeCookie}>
									<h2>{elem?.label}</h2>
									<p>{elem?.data}</p>
								</Style.FooterInfo>
							)
						})}

						<Style.LogoDiv>
							{logoImg && <img src={logo} alt='Logo' />}
						</Style.LogoDiv>
					</Style.FooterDiv>

					{!isBreak && (
						<Style.ResponsivePrizeDiv $themeType={themeCookie}>
							<Style.PrizeListDiv>
								<h2>Prize Pool</h2>
								<PrizeListMock prize_editor={prize_editor || []} />
							</Style.PrizeListDiv>
							{prizeData?.total && (
								<Style.TotlePrizeDiv>
									<h2>Total Prize</h2>
									<p>{prizeData?.total}</p>
								</Style.TotlePrizeDiv>
							)}
							<Style.ResponsiveLogoDiv>
								{logoImg && <img src={logoImg} alt='Logo' />}
							</Style.ResponsiveLogoDiv>
						</Style.ResponsivePrizeDiv>
					)}
				</Style.Wrapper>
			</>
		)
	}
)

Wrapper.displayName = 'Wrapper'

export default Wrapper
